import { configureStore } from '@reduxjs/toolkit';
import newsReducer from './news/slice';
import metaReducer from './meta/slice';
import onlineFreeUsersReducer from './onlineLadies/slice';
import servicesReducer from './services/slices';
import videoStoriesReducer from './videoStories/slice';
import testimonialsReducer from './testimonial/slice';
import authReducer from './auth/slice';
import liveChatReducer from './liveChat/slice';
import userFilesReducer from './files/slice';
import lettersReducer from './letters/slice';
import videoChatReducer from './videoChat/slice';
import fansReducer from './fans/slice';
import giftsReducer from './gifts/slice';
import agencyUserReducer from './agencyUser/slice';
import presentsReducer from './presents/slice';
import { persistStore } from 'redux-persist';
import websocketReducer from './websocket/slice';
import animationReducer from './animation/slice';
import settingsReducer from './settings/slice';
import liveChatSenderReducer from './liveChatSender/slice';
import usersReducer from './users/slice';
import purchasedPrivateMediaReducer from './purchasedPrivateMedia/slice';

export const store = configureStore({
  reducer: {
    meta: metaReducer,
    news: newsReducer,
    online: onlineFreeUsersReducer,
    services: servicesReducer,
    videoStories: videoStoriesReducer,
    videoChat: videoChatReducer,
    testimonials: testimonialsReducer,
    auth: authReducer,
    gifts: giftsReducer,
    liveChat: liveChatReducer,
    userFiles: userFilesReducer,
    letters: lettersReducer,
    fans: fansReducer,
    presents: presentsReducer,
    agencyUser: agencyUserReducer,
    websocket: websocketReducer,
    animation: animationReducer,
    settings: settingsReducer,
    liveChatSender: liveChatSenderReducer,
    users: usersReducer,
    purchasedPrivateMedia: purchasedPrivateMediaReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export const persistor = persistStore(store);
